import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'svc-vin-scanner',
  templateUrl: './vin-scanner.component.html',
  styleUrls: ['./vin-scanner.component.scss']
})
export class VinScannerComponent implements OnInit {
  configQuagga = {
    inputStream: {
      name: 'Live',
      type: 'LiveStream',
      target: '#inputBarcode',
      constraints: {
        width: { min: 640 },
        height: { min: 480 },
        aspectRatio: { min: 1, max: 100 },
        facingMode: 'environment' // or user
      },
      singleChannel: false // true: only the red color-channel is read
    },
    locator: {
      patchSize: 'medium',
      halfSample: true
    },
    locate: true,
    numOfWorkers: 4,
    decoder: {
      readers: ['code_128_reader']
    }
  };
  barcodeValue: string;
  constructor() {}

  ngOnInit() {}
}
